module.exports = __webpack_public_path__ + "static/home-features-person-3ae017887e2b95d3b98c16fcdb291c68.png";